import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { importsSalesforceStartReducers, importsSalesforceStartWatchers } from './start';
import { importsSalesforceSummaryReducers, importsSalesforceSummaryWatchers } from './summary';

export const importsSalesforceReducers = combineReducers({
	start: importsSalesforceStartReducers,
	summary: importsSalesforceSummaryReducers
});

export const importsSalesforceWatchers = combineAllWatchers([
	importsSalesforceStartWatchers,
	importsSalesforceSummaryWatchers
]);
